import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { inviteCompanyRoute, tampleteCreateRoute } from '@features/enterprise/api/constants';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { templateList } from '../constants';

type useInviteCompanyProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useInviteCompany = ({
    setErrorText = () => { },
}: useInviteCompanyProps) => {
    const client = useQueryClient();

    const { mutate: inviteCompany, isLoading: isInvitingCompany } =
        useMutation({
            mutationFn: (variables:
                {
                    email: string
                    etemplate_id: number | string
                }) =>
                axiosInstance
                    .post(inviteCompanyRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setErrorText(data.message);
                } else {
                    setErrorText('');
                    // client.invalidateQueries([templateList]);
                }
            },
            onError: () => setErrorText(errorMessage),
        });

    return {
        inviteCompany,
        isInvitingCompany,
    };
};
